import { Component, input } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'

@Component({
  selector: 'app-events-timeline-search-input',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './events-timeline-search-input.component.html',
  styleUrl: './events-timeline-search-input.component.scss'
})
export class EventsTimelineSearchInputComponent {
  public readonly searchControl = input.required<FormControl<string>>()
  public readonly widthClass = input('sm:tw-w-64')
}
